var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$isFlag ? "contentlistH5" : "contentlistWeb" },
    [
      _vm.$isFlag
        ? _c("common-navbar", { attrs: { "is-home-bar": true } })
        : _vm._e(),
      _vm.$isFlag
        ? _c("img", {
            staticStyle: { width: "100%" },
            attrs: {
              src: require("assets/images/accountCenter/bgcenter.png"),
              alt: ""
            }
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "entrance" },
        _vm._l(_vm.list, function(item, index) {
          return _c(
            "p",
            {
              key: index,
              on: {
                click: function($event) {
                  return _vm.typeClick(index)
                }
              }
            },
            [
              _vm.$isFlag
                ? _c("img", {
                    attrs: {
                      src: require("@/assets/images/accountCenter/" +
                        item.url +
                        ".png"),
                      alt: "",
                      srcset: ""
                    }
                  })
                : _c("img", {
                    attrs: {
                      src: require("@/assets/images/accountCenter/" +
                        item.webUrl +
                        ".png"),
                      alt: "",
                      srcset: ""
                    }
                  })
            ]
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }